import { useState } from 'react';
import { Dialog } from '@prenuvo/halo-foundation';

import { FCT } from '@/i18n';
import { useUnsavedChangesPrompt } from '@/shared/hook';

import { PatientContactConfirmationSection } from './patient-contact-confirmation-section';
import { PatientContactOutcomeSection } from './patient-contact-outcome-section';

export type PatientContactDialogProps = {
  closeDialog: (open: boolean) => void;
  open: boolean;
};

export function PatientContactDialog({ closeDialog, open }: PatientContactDialogProps) {
  const [reason, setReason] = useState<null | string>(null);
  const [confirmationSection, setConfirmationSection] = useState<boolean>(true);

  useUnsavedChangesPrompt(!confirmationSection);

  const handleCloseDialog = () => {
    setReason(null);
    setConfirmationSection(true);
    closeDialog(true);
  };

  return (
    <Dialog
      className={{
        content: 'h-auto w-[824px] max-w-max overflow-y-auto',
        header:
          'items-center bg-stone-950 p-5 text-lg text-neutral-50 dark:bg-stone-950 dark:text-neutral-50',
        title: 'text-md md:text-md mr-10 font-normal',
      }}
      onOpenChange={confirmationSection ? handleCloseDialog : () => closeDialog(false)}
      open={open}
      title={
        confirmationSection
          ? FCT.REPORTING.HEADER.CONTACT_DETAILS.CONFIRMATION_TITLE
          : FCT.REPORTING.HEADER.CONTACT_DETAILS.INFO_TITLE
      }
    >
      <div className="w-[824px] bg-stone-950 px-5 pb-5 dark:bg-stone-950">
        {confirmationSection ? (
          <PatientContactConfirmationSection
            onCancel={handleCloseDialog}
            onNext={() => setConfirmationSection(false)}
            reason={reason}
            setReason={setReason}
          />
        ) : (
          <PatientContactOutcomeSection closeDialog={handleCloseDialog} reason={reason!} />
        )}
      </div>
    </Dialog>
  );
}
